export const isPopulated = <T>(data: T | string): data is T => typeof data !== 'string'
export const isPopulatedArray = <T>(data: T | string[]): data is T => data && isPopulated(data[0])
